import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const banks = [
  { name: 'Emirates NBD', accounts: 142, status: 'Active Partner', logo: '🏦' },
  { name: 'Abu Dhabi Commercial Bank', accounts: 98, status: 'Active Partner', logo: '🏦' },
  { name: 'Dubai Islamic Bank', accounts: 87, status: 'Active Partner', logo: '🏦' },
  { name: 'First Abu Dhabi Bank', accounts: 134, status: 'Active Partner', logo: '🏦' },
  { name: 'Mashreq Bank', accounts: 76, status: 'Active Partner', logo: '🏦' },
  { name: 'RAKBANK', accounts: 45, status: 'Active Partner', logo: '🏦' }
];

const EscrowVerification = () => {
  const [accountNo, setAccountNo] = useState('');
  const [verified, setVerified] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleVerify = () => {
    if (!accountNo?.trim()) return;
    setLoading(true);
    setTimeout(() => {
      setVerified({
        accountNumber: accountNo,
        bank: 'Emirates NBD',
        projectName: 'Marina Heights Tower',
        developer: 'Emaar Properties',
        totalFunds: 'AED 245,800,000',
        releasedFunds: 'AED 89,200,000',
        heldFunds: 'AED 156,600,000',
        reraApproved: true,
        lastAudit: '2025-01-15',
        nextAudit: '2025-04-15'
      });
      setLoading(false);
    }, 1200);
  };

  return (
    <div className="rounded-2xl p-6" style={{ background: 'rgba(10,22,40,0.9)', border: '1px solid rgba(0,212,255,0.2)' }}>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)' }}>
          <Icon name="Lock" size={20} color="#00D4FF" />
        </div>
        <div>
          <h3 className="text-lg font-bold" style={{ color: '#E8F4FF' }}>Escrow Account Verification</h3>
          <p className="text-xs" style={{ color: '#6B9EC4' }}>Verify mandatory escrow arrangements with RERA-approved banks</p>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-3 mb-6">
        <input
          type="text"
          value={accountNo}
          onChange={e => setAccountNo(e?.target?.value)}
          placeholder="Enter escrow account number (e.g. ESC-2024-00123)"
          className="flex-1 px-4 py-3 rounded-xl text-sm outline-none"
          style={{ background: 'rgba(0,212,255,0.05)', border: '1px solid rgba(0,212,255,0.2)', color: '#E8F4FF' }}
        />
        <button
          onClick={handleVerify}
          disabled={loading}
          className="px-5 py-3 rounded-xl font-semibold text-sm"
          style={{ background: '#00D4FF', color: '#0A1628' }}
        >
          {loading ? 'Verifying...' : 'Verify Escrow'}
        </button>
      </div>
      {verified && (
        <div className="rounded-xl p-4 mb-6" style={{ background: 'rgba(34,197,94,0.08)', border: '1px solid rgba(34,197,94,0.25)' }}>
          <div className="flex items-center gap-2 mb-4">
            <Icon name="CheckCircle" size={18} color="#22c55e" />
            <span className="font-semibold text-sm" style={{ color: '#22c55e' }}>Escrow Account Verified</span>
          </div>
          <div className="grid grid-cols-2 gap-3">
            {[
              { label: 'Bank', value: verified?.bank },
              { label: 'Project', value: verified?.projectName },
              { label: 'Developer', value: verified?.developer },
              { label: 'RERA Approved', value: verified?.reraApproved ? '✓ Yes' : '✗ No' },
              { label: 'Total Funds', value: verified?.totalFunds },
              { label: 'Held Funds', value: verified?.heldFunds },
              { label: 'Last Audit', value: verified?.lastAudit },
              { label: 'Next Audit', value: verified?.nextAudit }
            ]?.map((item, i) => (
              <div key={i} className="p-2 rounded-lg" style={{ background: 'rgba(10,22,40,0.6)' }}>
                <div className="text-xs" style={{ color: '#6B9EC4' }}>{item?.label}</div>
                <div className="text-sm font-medium" style={{ color: '#E8F4FF' }}>{item?.value}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      <div>
        <h4 className="text-sm font-semibold mb-3" style={{ color: '#E8F4FF' }}>RERA-Approved Escrow Banks</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {banks?.map((bank, i) => (
            <div key={i} className="flex items-center gap-3 p-3 rounded-xl" style={{ background: 'rgba(0,212,255,0.05)', border: '1px solid rgba(0,212,255,0.12)' }}>
              <span className="text-xl">{bank?.logo}</span>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium truncate" style={{ color: '#E8F4FF' }}>{bank?.name}</div>
                <div className="text-xs" style={{ color: '#6B9EC4' }}>{bank?.accounts} active escrow accounts</div>
              </div>
              <span className="text-xs px-2 py-0.5 rounded-full" style={{ background: 'rgba(34,197,94,0.1)', color: '#22c55e' }}>Active</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EscrowVerification;
